import { Button, Group, Text } from "@mantine/core";
import classes from "./SingleIssuanceWizard.module.css";

const WizardFooter = ({
  activeStep,
  stepsCount,
  canNext,
  onBack,
  onNext,
  showGenerateLink,
  onGenerateLink,
}) => {
  const isLastStep = activeStep === stepsCount - 1;

  const continueLabel =
    activeStep === 1 ? "Continue to Travelers" : "Continue";

  return (
    <footer className={classes.footer}>
      <Group justify="space-between" wrap="nowrap">
        <Button
          variant="subtle"
          color="gray"
          onClick={onBack}
          disabled={activeStep === 0}
        >
          Back
        </Button>

        <Text size="sm" c="dimmed" visibleFrom="sm">
          Step {activeStep + 1} of {stepsCount}
        </Text>

        <Group gap="sm">
          {showGenerateLink && (
            <Button variant="outline" color="brand" onClick={onGenerateLink}>
              Generate Link
            </Button>
          )}
          {!isLastStep && (
            <Button color="brand" onClick={onNext} disabled={!canNext}>
              {continueLabel}
            </Button>
          )}
        </Group>
      </Group>
    </footer>
  );
};

export default WizardFooter;
